import { Alert, Card, List, Typography } from 'antd';
import type { AiTextPayload } from '../../../types/ai-analysis.types';
export default function AiSummaryAnalysisView({ payload }: { payload: AiTextPayload }) {
  return (
    <Card title={payload.title}>
      <Typography.Paragraph>{payload.synthesis}</Typography.Paragraph>
      <List
        dataSource={payload.findings}
        renderItem={(finding) => (
          <List.Item>
            {finding.heading}: {finding.text}
          </List.Item>
        )}
      />
      <Alert type="info" message="Nota metodológica" description={payload.methodologyNote} />
    </Card>
  );
}
